<template>
  <ContentPage>
    <template #header>
      <Progress :step="1" :steps="5">
        <h2>Welcome to PartnerLists</h2>
      </Progress>
    </template>


    <div class="rounded-lg white py-6 px-8 text-justify" style="font-size: 18px">
      <p class="mb-6">
        One of your partners has invited you to the best system for
        Pros to get leads from businesses they already know and trust.
      </p>

      <p class="primary--text mb-6" v-if="me.lead_count>0">
        <strong>You currently have {{ me.lead_count }} leads waiting.</strong>
      </p>

      <p class="mb-6">
        To start your 30-day free trial, we need a few bits of
        information from you.
      </p>

      <p class="primary--text" @click="nextClick"><strong>Let's get started!</strong></p>
    </div>

    <template #footer>
      <div class="d-flex justify-center py-2 rounded-lg white">
        <v-btn color="primary" class="ml-4" @click="nextClick">Next</v-btn>
      </div>
    </template>
  </ContentPage>
</template>

<script>
import { ContentPage } from '@/components/pages'
import Progress from './progress'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "WizardStepA",

  components: { ContentPage, Progress },

  computed: mapGetters('auth', ['me']),

  methods: {
    ...mapActions('auth', ['loadMe']),

    nextClick() {
      this.$router.replace( { name: 'wizardB' } )
    },
  },

  created() {
    this.loadMe();
  }
}
</script>
